module.exports = __webpack_public_path__ + "img/stars.74356439.gif";